import React, { useState } from "react";

function ClipboardCopy({ BrandToken }) {
  const [copied, setCopied] = useState(false);
  const [textToCopy, setTextToCopy] = useState(`
  <script src="https://cdn.convobird.com/media/chat-widget.umd.cjs" token="${BrandToken}"></script>`);

    // <script src="https://cdnnew.convobird.com/media/index.js" token="${BrandToken}"></script>`);
  const copyToClipboard = () => {
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = textToCopy;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    setCopied(true);
  };

  const handleDivClick = () => {
    copyToClipboard();
  };

  return (
    <div className="clipboard">
      <div className="copiedArea" onClick={handleDivClick}>
        {textToCopy}
      </div>
      {copied && (
        <div>
          <div className="copiedText">Copied to clipboard!</div>
        </div>
      )}
    </div>
  );
}

export default ClipboardCopy;